export default __webpack_public_path__ + "static/media/next.25a9c34a.svg";